import { Link } from "react-router-dom";
import { useApi } from "../lib/api";
import { Badge, Button, Card, Empty, ErrorNote, fmtDate, Loading, Table, Td } from "../components/ui";

export default function Campaigns() {
  const { data, error, loading } = useApi<any[]>("/campaigns");
  if (loading && !data) return <Loading />;
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-[1.45rem] font-semibold tracking-tight">Campaigns</h1>
        <Link to="/campaigns/new"><Button tone="primary">New campaign</Button></Link>
      </div>
      <ErrorNote error={error} />
      <Card>
        {!data?.length ? (
          <Empty title="No campaigns yet" action={<Link to="/campaigns/new"><Button tone="primary">New campaign</Button></Link>}>Describe who you want to reach and Claude drafts one sequence for the whole campaign.</Empty>
        ) : (
          <Table head={["Campaign", "Offering", "Rep", "Contacts", "Sequence", "Created"]}>
            {data.map((c) => (
              <tr key={c.id}>
                <Td><Link className="font-medium text-accent-text hover:underline" to={`/campaigns/${c.id}`}>{c.name}</Link></Td>
                <Td>{c.offering}</Td>
                <Td>{c.ownerName}</Td>
                <Td className="tabular-nums">{c.counts?.enrolled ?? "—"}</Td>
                <Td><Badge tone={c.draftStatus ?? c.status}>{c.status === "paused" ? "paused" : c.draftStatus === "ready" ? "ready to review" : c.draftStatus === "queued" || c.draftStatus === "drafting" ? "drafting" : c.draftStatus ?? c.status}</Badge></Td>
                <Td className="whitespace-nowrap text-muted">{fmtDate(c.createdAt)}</Td>
              </tr>
            ))}
          </Table>
        )}
      </Card>
    </div>
  );
}
